<script>
import { mapState, mapActions } from 'vuex';
/* components */
// import CustomComponent from '@/components/CustomComponent';
/* tools */
import { isFunction } from '@/scripts/utils';

export default {
  name: 'Button',
  components: {
    // CustomComponent,
  },
  props: {
    to: {
      type: String,
      default: '',
    },
    href: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    back: {
      type: Boolean,
      default: false,
    },
    tabindex: {
      type: String,
      default: '',
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['user']),
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions({}),
    action(e) {
      const {
        $listeners: { click },
        back,
      } = this;

      if (isFunction(click)) {
        this.$emit('click', e);
      } else if (back) {
        this.$router.back();
      }
    },
  },
};
</script>

<template>
  <!-- internal link -->
  <router-link v-if="to" :to="to" :class="{ button: true, disabled: disabled }">
    <slot />
    <slot name="icon" />
  </router-link>
  <!-- external link -->
  <a
    v-else-if="href"
    :href="href"
    :class="{ button: true, disabled: disabled }"
    :tabindex="tabindex"
    :autofocus="autofocus"
    target="_blank"
  >
    <slot />
    <slot name="icon" />
  </a>
  <!-- button -->
  <button
    v-else
    :class="{ button: true, default: $slots.default, disabled: disabled }"
    :tabindex="tabindex"
    :autofocus="autofocus"
    @click="action"
  >
    <slot />
    <slot name="icon" />
  </button>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.button {
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: 0;
  transition: all 0.2s;
  cursor: pointer;
  text-decoration: none;

  &.back {
    width: 70px;
    height: 57px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background-color: #232e33;

    ::v-deep img {
      display: flex;
      width: 16px;
      height: 14px;
      user-select: none;
    }

    &:hover,
    &:focus {
      background-color: rgba(35, 46, 51, 0.5);
    }
  }

  &.visible-mobile {
    display: none;
  }

  &.default {
    height: 44px;
    border-radius: 17px;
    min-width: 170px;
    outline: none;
    padding: 5px 10px;
    font-family: Poppins-Medium;
    font-size: 14px;
    line-height: 20px;
    color: #fff;
    text-decoration: none;

    &:hover {
      opacity: 0.5;
    }
  }

  &.sm {
    font-family: Sen-Bold;
    height: 36px;
    min-height: 36px;
    min-width: 108px;
  }

  &.orange {
    background-color: #ffc107;
    color: #0d0d0d;

    &.lg {
      font-family: Sen-Bold;
      font-size: 16px;
      line-height: 19px;
      min-width: 180px;
      border-radius: 22px;
    }
  }

  &.negative {
    background-color: #f95862;
    color: #0d0d0d;
  }

  &.positive {
    background-color: #38d5b8;
    color: #ffffff;
  }

  &.blue {
    background-color: #4e7cff;
    color: #ffffff;
  }

  &.copy {
    border-radius: 12px;
    background-color: rgba(255, 193, 7, 0.1);
    min-height: 36px;
    height: 36px;
    min-width: 93px;
    color: #ffc107;
    font-family: Poppins-Regular;

    &:hover {
      opacity: 1;
      background-color: rgba(255, 193, 7, 0.3);
    }
  }

  &.boost {
    min-width: auto;
    width: 100%;
    border-radius: 12px;
    background: linear-gradient(
      251deg,
      rgba(255, 91, 148, 1) 0%,
      rgba(132, 65, 164, 1) 94%
    );
    height: 36px;
    padding: 8px 15px;
    font-family: Sen-Regular;
    font-size: 14px;
    line-height: 19px;
    color: #fff;

    &:hover {
      opacity: 1;
      background: linear-gradient(
        200deg,
        rgba(255, 91, 148, 1) 0%,
        rgba(132, 65, 164, 1) 94%
      );
    }

    &.lg {
      font-size: 16px;
      height: 40px;
      max-width: 228px;
    }
  }

  &.lg-width {
    max-width: 344px;
    width: 100%;
  }

  &.link-white {
    font-family: Poppins-Medium;
    font-size: 14px;
    line-height: 20px;
    text-decoration: underline;
    color: rgba(255, 255, 255, 0.7);

    &:hover {
      text-decoration: none;
    }
  }

  &.link-input {
    min-width: auto;
    padding: 0;
    border: 0;
    background: transparent;
    border-radius: 0;
    font-family: Poppins-Light;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
    text-decoration: underline;
    transition: all 0.2s;
    cursor: pointer;
    z-index: 1;

    &:hover {
      text-decoration: none;
    }
  }

  &.link-terms {
    font-family: Poppins-Regular;
    font-size: 12px;
    line-height: 21px;
    color: rgba(255, 255, 255, 0.7);
    text-decoration: none;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  &.icon {
    min-height: 36px;
    height: 36px;
    padding: 5px 25px;
    background: transparent;
    border-radius: 18px;
    border: solid 1px;
    min-width: auto;
    font-family: Sen-Bold;
    text-decoration: none;
    line-height: 17px;

    ::v-deep img {
      width: 16px;
      height: 16px;
      display: flex;
      margin-right: 10px;
    }

    &.logout {
      border-color: #ffc107;
      color: #ffc107;
    }

    &.dash {
      background-color: #ffc107;
      border-color: #ffc107;
      color: #3a3a3a;
    }

    &.leaderboard {
      border-color: #ffc107;
      color: #ffc107;
    }
  }

  &.disabled {
    user-select: none;
    pointer-events: none;
    opacity: 0.5;
  }

  &.steam {
    max-width: 370px;
    width: 100%;
    height: 80px;
    border-radius: 12px;
    background-color: #1d2429;
    text-decoration: none;
    outline: none;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    cursor: pointer;

    img {
      display: flex;
      max-height: 40px;
      user-select: none;
    }

    &:hover {
      background-color: rgba(29, 36, 41, 0.5);
    }
  }

  &.refresh {
    height: 36px;
    min-width: 109px;
    border-radius: 12px;
    background-color: #1d2429;
    padding: 5px 10px;
    outline: none;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row-reverse;
    cursor: pointer;
    font-family: Poppins-Regular;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
    border: 0;
    transition: all 0.2s;

    img {
      width: 15px;
      height: 15px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      user-select: none;
      flex-shrink: 0;
    }

    &:not(.is-active):hover {
      background-color: rgba(29, 36, 41, 0.5);
    }

    &.is-active {
      img {
        animation-name: spin;
        animation-duration: 5s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
      }
    }
    &:disabled {
      pointer-events: none;
      user-select: none;
      opacity: 0.7;
    }
  }
}

.link {
  font-family: Sen-Bold;
  font-size: 14px;
  line-height: 17px;
  color: #ffc107;
  text-decoration: none;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: $mobile) {
  .button {
    &.hide-mobile {
      display: none;
    }

    &.visible-mobile {
      display: flex;
    }

    &.back {
      width: 19px;
      height: 16px;
      border-radius: none;
      background-color: transparent;
      padding: 0;

      img {
        width: 100%;
        height: 100%;
      }

      &:focus,
      &:hover {
        background-color: transparent;
      }
    }

    &.default {
      &:hover {
        opacity: 1;
      }
    }

    &.sm {
      font-size: 12px;
      line-height: 14px;
      min-width: 100px;
    }

    &.m-290 {
      width: 100%;
      max-width: 290px;
    }

    &.orange {
      &.lg {
        min-width: 240px;
      }
    }

    &.copy {
      width: 44px;
      height: 44px;
      min-width: auto;
      border-radius: 8px;
      border: solid 1px rgba(255, 193, 7, 0.2);
      background-color: rgba(255, 193, 7, 0.1);
      font-size: 0;
      flex-shrink: 0;
      position: relative;

      &:before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 15px;
        height: 16px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
        background-image: url('~@/assets/svg/copy.svg');
      }
    }

    &.link-white {
      &.sm-m {
        font-size: 12px;
        line-height: 17px;
        color: #ffffff;
      }
    }

    &.icon {
      font-size: 16px;
      line-height: 19px;
      min-width: 240px;
      min-height: 44px;
      height: 44px;
    }

    &.refresh {
      width: 44px;
      height: 44px;
      font-size: 0;
      min-width: auto;

      img {
        margin-right: 0;
      }
    }
  }

  .link {
    &.sm {
      font-size: 12px;
      line-height: 14px;
    }
  }
}
</style>
